import { HourglassBottom } from "@mui/icons-material";
import { styled, Typography } from "@mui/material";
import ReactPlayer from "react-player";

const Wrapper = styled("div", {
  shouldForwardProp: (prop) => prop !== "aspectRatio",
})(({ theme, aspectRatio }) => ({
  aspectRatio,
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.grey["500"],
  justifyContent: "center",
  alignItems: "center",
  color: "white",
}));

export default function LoadingPostContent({ postData }) {
  return (
    <Wrapper
      className={"post_content post_content_loading"}
      aspectRatio={postData.proporcaoImagem || " 4 / 5"}
    >
      <HourglassBottom />
      <Typography>Conteúdo carregando...</Typography>
    </Wrapper>
  );
}
